<template>
	<div class="header-time">
		<div class="header-item">
			<img class="item-icon" src="../../assets/image/icon_calendar.png">
			<span class="item-content">{{this.dateDay}}</span>
		</div>

		<div class="header-item">
			<img class="item-icon" src="../../assets/image/icon_time.png">
			<span class="item-content">{{this.dateTime}}</span>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			dateDay: "",
			dateTime: "",
			timer: null
		}
	},
	mounted() {
		this.getTime();

		if(this.timer){
			clearInterval(this.timer);
			this.timer = null;
		}

		this.timer = setInterval(()=>{
			this.getTime();
		},60000);
	},
	methods: {
		getTime(){
			const date = this.$moment();
			this.dateDay = date.format("YYYY年M月D日") + " 星期" + this.$util.convertNumToChinese(date.weekday());
			this.dateTime = date.format("HH:mm")
		}
	}
}
</script>

<style scoped lang="scss">
.header-time{
	height: 75px;
	display: flex;
	flex-direction: row;
	align-items: center;
}
.header-item{
	margin-right: 70px;
	display: flex;
	flex-direction: row;
	align-items: center;
	&:last-child{
		margin-right: 0;
	}
	.item-icon{
		width: 36px;
		height: 36px;
		margin-right: 10px;
	}
	.item-content{
		font-size: 28px;
		color: #B4E4FF;
		&.address{
			font-size: 36px;
			font-family: "screen", serif;
		}
	}
}
</style>
